import { useRef } from 'react';
import { TooltipV2 } from '../tooltip/TooltipV2';
import useIsClamped from '../../hooks/use-line-clamp-active';

const MIN_LINES = 1;
const MAX_LINES = 5;

export type TextProps = {
    /**
     * Classname styling to apply
     */
    className: string;
    /**
     * Number of lines to clamp text (default 1, max 5)
     */
    lines?: number;
    /**
     * Content to render
     */
    children: string;
};

function Text({ lines = MIN_LINES, className, children }: TextProps): JSX.Element {
    const textRef = useRef(null);
    const isClamped = useIsClamped(textRef);

    // Lines must be within min and max values. Default to min if out of bounds
    lines = Math.min(Math.max(lines, MIN_LINES), MAX_LINES);

    return (
        <p
            ref={textRef}
            className={`${className} overflow-hidden break-words`}
            style={{ display: '-webkit-box', WebkitBoxOrient: 'vertical', WebkitLineClamp: lines }}
        >
            <TooltipV2 message={children} disabled={!isClamped} delayMs={750}>
                <span className="w-fit">{children}</span>
            </TooltipV2>
        </p>
    );
}

export default Text;
